import BreadCrumb from "components/Common/BreadCrumb";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import ModalPreview from "components/Common/ModalPreview";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import {
  COLOR_INQUIRY_STATUS,
  INQUIRY_STATUS,
  LIST_OPTION_USER_ACCOUNT_TYPE,
} from "helpers/constans";
import {
  formatDateStringToKorea,
  formatDateStringToUTC,
  formatISOString,
} from "helpers/format";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import CountUp from "react-countup";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import { getInquiryList } from "store/inquiry-list/thunk";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";

import TooltipCustom from "components/Common/TooltipCustom";
import { Link } from "react-router-dom";
import InquiryForm from "./Form";
import CollapseFilter from "components/Common/CollapseFilter";
import LabelWrapper from "components/Common/LabelWrapper";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import inquiryListApi from "api/inquiryListApi";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";

registerLocale("en", en);
registerLocale("ko", ko);

const InquiryList = () => {
  const { t, i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [statusSearch, setStatusSearch] = useState<any>(null);
  const [keywordSearch, setKeywordSearch] = useState<any>("");
  const [serviceTypeSearch, setServiceTypeSearch] = useState<any>(null);
  const [inquiryTypeSearch, setInquiryTypeSearch] = useState<any>(null);
  const [dataInquiryTypes, setDataInquiryTypes] = useState<any>([]);

  const [query, setQuery]: any = useQueryParams({
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    status: withDefault(StringParam, ""),
    keyword: withDefault(StringParam, ""),
    serviceType: withDefault(StringParam, ""),
    inquiryTypeId: withDefault(StringParam, ""),
    createdFrom: withDefault(StringParam, ""),
    createdTo: withDefault(StringParam, ""),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.createdFrom
      ? moment(query?.createdFrom || "", "Y-MM-DD").toDate()
      : null,
    query?.createdTo
      ? moment(query?.createdTo || "", "Y-MM-DD").toDate()
      : null,
  ]);
  const [createdFrom, createdTo] = dateSearch;
  const searchData = () => {
    setQuery({
      ...query,
      keyword: keywordSearch ? encodeURIComponent(keywordSearch) : "",
      status: statusSearch,
      serviceType: serviceTypeSearch?.toLowerCase(),
      inquiryTypeId: inquiryTypeSearch,
      createdFrom: createdFrom
        ? formatISOString(
            moment(new Date(createdFrom))
              .startOf("day")
              .format("Y-MM-DD HH:mm:ss")
          )
        : "",
      createdTo: createdTo
        ? formatISOString(
            moment(new Date(createdTo)).endOf("day").format("Y-MM-DD HH:mm:ss")
          )
        : "",
      page: 1,
      time_request: +new Date(),
    });
  };

  const [linkImage, setLinkImage] = useState<any>(null);

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.InquiryList;
  const AdvertisementProperties = createSelector(
    selectLayoutState,
    (state) => ({
      inquiries: state.inquiries,
      isInquiryLoading: state.isInquiryLoading,
      isInquirySuccess: state.isInquirySuccess,
      error: state.error,
    })
  );

  const resetData = () => {
    setQuery(
      {
        page: 1,
        limit: 30,
        status: "",
        keyword: "",
        serviceType: "",
        inquiryTypeId: "",
        createdFrom: "",
        createdTo: "",
      },
      "push"
    );

    setKeywordSearch((_prev: any) => "");
    setServiceTypeSearch((_prev: any) => "");
    setInquiryTypeSearch((_prev: any) => "");
    setStatusSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const { inquiries, isInquiryLoading } = useSelector(AdvertisementProperties);

  const loadTableData = async () => {
    try {
      dispatch(getInquiryList(query));
    } catch {
      console.log("log data");
    }
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 80,
        thClass: "align-middle whitespace-nowrap",
        Cell: ({ ...props }) => {
          const item = props?.row?.original;
          return (
            <div style={{ display: "inline-flex", minWidth: "60px" }}>
              <div>
                {inquiries?.pagination?.total -
                  ((query?.page - 1) * query?.limit + props?.row?.index)}
              </div>
            </div>
          );
        },
      },
      {
        Header: t("Status"),
        accessor: "status",
        thWidth: 160,
        thClass: "align-middle text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;

          return (
            <div className="text-center" style={{ minWidth: 140 }}>
              <span
                className={`rounded-pill badge bg-${
                  COLOR_INQUIRY_STATUS[item?.status] || "secondary"
                }`}
              >
                {t(
                  INQUIRY_STATUS?.find(
                    (i: any) => String(i?.value) === String(item?.status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("serivce_type"),
        accessor: "serivce_type",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="capitalize" style={{ textTransform: "capitalize" }}>
              {cell?.value}
            </div>
          );
        },
      },
      {
        Header: t("Type"),
        accessor: "inquiry_type.name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 250,
        Cell: (cell: any) => {
          return <div className="whitespace-nowrap">{cell?.value}</div>;
        },
      },
      {
        Header: t("company_name"),
        accessor: "company_name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return <div className="whitespace-nowrap">{cell?.value}</div>;
        },
      },
      {
        Header: t("Contact Name"),
        accessor: "contact_name",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return <div className="whitespace-nowrap">{cell?.value}</div>;
        },
      },
      {
        Header: t("Contact Email"),
        accessor: "contact_email",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return <div className="whitespace-nowrap">{cell?.value}</div>;
        },
      },
      {
        Header: t("Content"),
        accessor: "contents",
        filterable: true,
        sortable: false,
        thClass: "align-middle whitespace-nowrap",
        thWidth: 260,
        Cell: (cell: any) => {
          const [show, setShow] = useState(false);
          const [isOverflowed, setIsOverflowed] = useState(false);
          const contentRef = useRef<any>(null);

          useEffect(() => {
            const el = contentRef.current;
            if (el) {
              setIsOverflowed(el.scrollWidth > el.offsetWidth);
            }
          }, [cell?.value]);

          return (
            <div
              style={{
                width: "400px",
                position: "relative",
                whiteSpace: show ? "normal" : "nowrap",
                overflow: "hidden",
                textOverflow: show ? "unset" : "ellipsis",
              }}
              ref={contentRef}
            >
              {cell?.value}
              {isOverflowed && (
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    setShow(!show);
                  }}
                  style={{
                    backgroundColor: "white",
                    position: show ? "static" : "absolute",
                    right: 0,
                    paddingLeft: "4px",
                    cursor: "pointer",
                    color: "#0086d2",
                  }}
                >
                  {show ? t("less") : t("more")}
                </span>
              )}
            </div>
          );
        },
      },
      {
        Header: t("Attachments"),
        accessor: "attachments",
        thClass: "align-middle text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 230,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const isVideo =
            item?.attachments?.[0]?.path &&
            (item?.attachments?.[0]?.type === "video" ||
              (item?.attachments?.[0]?.type === "file" &&
                item?.attachments?.[0]?.path?.includes(".mp4")));
          const imgUrl = item?.attachments?.[0]?.path;
          return imgUrl ? (
            <>
              <div className="w-100 text-center" style={{ minWidth: "10px" }}>
                <div
                  // style={{ width: "90px" }}
                  className="m-auto cursor-pointer"
                  onClick={() => {
                    if (item?.attachments?.length > 1) {
                      setLinkImage({
                        urls: item?.attachments?.map((i: any) => {
                          return { ...i, url: i?.path };
                        }),
                        keyword: {
                          title: item?.filename,
                          keyword: item?.filename,
                        },
                        isVideo,
                      });
                    } else {
                      setLinkImage({ url: imgUrl, isVideo });
                    }
                    document.body.className = "modal-open_img";
                  }}
                >
                  {isVideo ? (
                    <video width="100" height="100" controls key={imgUrl}>
                      <source src={imgUrl} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={imgUrl}
                      style={{ width: "100px" }}
                      className="flex-shrink-0 rounded"
                      alt="thumbnail"
                      // onError={({ currentTarget }) => {
                      //   currentTarget.onerror = null; // prevents looping
                      //   currentTarget.src = noImageJob;
                      // }}
                    />
                  )}
                </div>
              </div>
            </>
          ) : (
            <div className=""></div>
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "80px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },

      {
        Header: t("Button Action"),
        thClass: "align-middle text-center whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          return (
            <ul
              className="list-inline d-flex flex-wrap hstack gap-2 mb-0 "
              style={{ justifyContent: "center", minWidth: 100 }}
            >
              <TooltipCustom
                title={t("Button Update")}
                id={`update-md-${item?.id}`}
              >
                <Link
                  className="btn btn-sm btn-soft-primary edit-item-btn"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsOpen(true);
                    setItemToEdit(item);
                  }}
                >
                  <i className="ri-pencil-fill align-bottom "></i>
                </Link>
              </TooltipCustom>
            </ul>
          );
        },
      },
    ],
    [i18n?.language, inquiries?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  const onCloseClick = () => {
    setItemToEdit((_prev: any) => null);
    setIsOpen((_prev) => false);
  };

  const triggerRefresh = () => {
    onCloseClick();
    loadTableData();
  };

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [inquiryTypes]: any = await Promise.all([
          inquiryListApi.inquiryTypes(),
        ]);

        if (inquiryTypes?.data) {
          const formatOptionType = inquiryTypes?.data?.map((item: any) => ({
            label: item?.name,
            value: item?.id,
          }));
          setDataInquiryTypes(formatOptionType);
        }
      } catch (error: any) {
        return error;
      }
    };
    handleCallAllOption();
  }, []);

  useEffect(() => {
    loadTableData();
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("Inquiry Management")} | ShowStart`;
    document.body.classList.remove("vertical-sideinquiry-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Inquiry Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row
                    className="g-4 align-items-center"
                    style={{ height: "63px" }}
                  >
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={inquiries?.pagination?.total}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 ">
                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper label={t("serivce_type")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={LIST_OPTION_USER_ACCOUNT_TYPE || []}
                            placeholder={`${t("Select serivce type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={serviceTypeSearch}
                            onChangeSelect={(e: any) =>
                              setServiceTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={3} xl={3} xxl={3} className="mt-3 ">
                        <LabelWrapper label={t("Inquiry Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type"
                            dataList={dataInquiryTypes || []}
                            placeholder={`${t("Select inquiry type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={inquiryTypeSearch}
                            onChangeSelect={(e: any) =>
                              setInquiryTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Status")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={INQUIRY_STATUS || []}
                            placeholder={`${t("Select status")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={statusSearch}
                            onChangeSelect={(e: any) =>
                              setStatusSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_INQUIRY_STATUS}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!createdFrom || !!createdTo}
                        >
                          <DatePickerCustom
                            startDate={createdFrom || null}
                            endDate={createdTo || null}
                            onChangePicker={(values: any) =>
                              setDateSearch((_prev: any) => values)
                            }
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={9}
                        xl={9}
                        xxl={9}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass={`align-middle table-bordered-dashed`}
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={inquiries?.items?.length ? inquiries?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={inquiries?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(inquiries?.pagination?.total) /
                          Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sortBy,
                        order_by: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isInquiryLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        {isOpen && (
          <InquiryForm
            setIsOpen={setIsOpen}
            id={itemToEdit?.id}
            setItemToEdit={setItemToEdit}
            triggerRefresh={triggerRefresh}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default InquiryList;
